import {createContext, getContextOrThrow} from 'src/core';
import type {ReportDetailOptions} from './types';

const reportDetailOptionsContextKey = Symbol('report-detail-options-ctx');

export function createReportDetailContext(options: ReportDetailOptions): ReportDetailOptions {
    return createContext(reportDetailOptionsContextKey, options);
}

export function getReportDetailContext(): ReportDetailOptions {
    return getContextOrThrow(reportDetailOptionsContextKey);
}